module.exports = __webpack_public_path__ + "img/greentick.76b8c51e.svg";